// src/components/TagSelector.js
import React ,{useState} from "react";
import {
  Grid,
  Box,
  FormControl,
  Typography,
  IconButton,
  Chip,
  Menu,
  MenuItem,
  Avatar,
} from "@mui/material";
import LabelIcon from "@mui/icons-material/Label";
import AddIcon from "@mui/icons-material/Add";
import { blue } from "@mui/material/colors";

const TagSelector = ({
  ticketData,
  setTicketData,
  raiseTicket,
  displayAlertMessage,
  message,
  tagList,
  workTimerRef,
  WorkTimer,
}) => {
  const [anchorElLabel, setAnchorElLabel] = useState(null);

  const handleLabelClick = (event) => {
    setAnchorElLabel(event.currentTarget);
  };

  const handleCloseLabelMenu = () => {
    setAnchorElLabel(null);
  };

  const handleToggleLabel = (labelId) => {
    let updatedSelected;
    if (
      ticketData.tags &&
      ticketData.tags.length > 0 &&
      ticketData.tags.includes(labelId)
    ) {
      // Remove the labelId if it is already in the list
      updatedSelected = ticketData.tags.filter((id) => id !== labelId);
    } else {
      // Add the labelId to the list
      updatedSelected = [...ticketData.tags, labelId];
    }

    const updatedFormData = {
      ...ticketData,
      tags: updatedSelected,
    };

    if (
      ticketData.tags &&
      ticketData.tags.length > 0 &&
      ticketData.tags.includes(labelId)
      && raiseTicket(updatedFormData)
    ) {
      displayAlertMessage(message.removeTag);

    } else {
      displayAlertMessage(message.addTag);

    }
    // Update ticketData.tags with the new list of selected labels
    setTicketData(updatedFormData);
    raiseTicket(updatedFormData)
    return updatedSelected; // Return the updated selected labels list
  };

  return (
    <Grid container spacing={1}>
      <Grid item xs={10}>
        <Box>
          <FormControl fullWidth>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                flexWrap: "wrap",
                minHeight: "44px",
                borderRadius: "8px",
                padding: "6px 8px",
                gap: 1,
              }}
            >
              {/* Label Icon */}
              <LabelIcon color="primary" />

              {/* Selected Tags */}
              {ticketData.tags && ticketData.tags.length > 0 ? (
                ticketData.tags.map((tagId) => {
                  const tag = tagList.find((t) => t.id === tagId);
                  return (
                    tag && (
                      <Chip
                        key={tag.id}
                        label={tag.value}
                        color="primary"
                        onDelete={() => handleToggleLabel(tag.id)}
                        sx={{
                          fontSize: "13px",
                          fontWeight: 500,
                        }}
                      />
                    )
                  );
                })
              ) : (
                <Typography
                  component="div"
                  variant="body2"
                  color="primary"
                  sx={{ ml: 1 }}
                >
                  Tags
                </Typography>
              )}

              {/* Add (+) Icon */}
              <IconButton
                size="small"
                sx={{
                  backgroundColor: "#e3f2fd", // Light blue tone for primary
                  color: "#1976d2", // MUI primary main color
                  borderRadius: "50%",
                  "&:hover": {
                    backgroundColor: "#bbdefb",
                  },
                }}
                onClick={handleLabelClick}
              >
                <AddIcon />
              </IconButton>
            </Box>

            {/* Tag Selection Menu */}
            <Menu
              anchorEl={anchorElLabel}
              open={Boolean(anchorElLabel)}
              onClose={handleCloseLabelMenu}
            >
              {tagList.length > 0 ? (
                tagList.map((label) => (
                  <MenuItem
                    key={label.id}
                    onClick={() => handleToggleLabel(label.id)}
                    sx={{
                      width: "180px",
                      fontSize: "12px",
                      backgroundColor:
                        ticketData.tags && ticketData.tags.includes(label.id)
                          ? "#eff4ff"
                          : "transparent",
                      "&:hover": {
                        backgroundColor: "#f5f7fa",
                      },
                    }}
                  >
                    <Avatar
                      sx={{
                        width: 20,
                        height: 20,
                        fontSize: "11px",
                        backgroundColor: blue[500],
                        color: "white",
                        mr: 1,
                      }}
                    >
                      {label.value.charAt(0).toUpperCase()}
                    </Avatar>
                    {label.value}
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>No Tags</MenuItem>
              )}
            </Menu>
          </FormControl>
        </Box>
      </Grid>
      <Grid item xs={2}>
        <WorkTimer
          ref={workTimerRef}
          workTime={ticketData.totalWorkSeconds}
          ticketNumber={ticketData.id}
        />
      </Grid>
    </Grid>
  );
};

export default TagSelector;
